import { Injectable } from '@angular/core';
import { API_URLS } from '@app/constants/apiUrls';
import { ApiHelper } from '@app/helpers';
import axios from 'axios';

@Injectable({
  providedIn: 'root'
})
export class FileUploaderService {

  constructor(private apiHelper: ApiHelper) { }

  uploadUsingPreSignedUrl({ fileName, contentType, file }: any) {
    return new Promise((resolve, reject) => {
      this.apiHelper.post(API_URLS.FILE_UPLOADER, { fileName, contentType }).subscribe({
        next: (res: any) => {
          const imageForm = new FormData();
          imageForm.append('file', file);
          let data = file;

          let config = {
            method: 'put',
            maxBodyLength: Infinity,
            url: res.data.url,
            headers: {
              'Content-Type': contentType
            },
            data: data
          };

          axios.request(config)
            .then((response) => {
              resolve({
                url: res.data.url.split("?")[0]
              })
            })
            .catch((error) => {
              reject(error)
            });
        },
        error: (err) => {
          return reject(err)
        }
      })
    })
  }
}
